import axios from 'axios';
// config
// ----------------------------------------------------------------------

const axiosInstance = axios.create({
  // baseURL: HOST_API,
  baseURL: 'https://minimal-assets-api-dev.vercel.app',
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong')
);

export default axiosInstance;
